import React from 'react';
import LoggedInHeader, { hasLoggedInHeaderEnvironmentBanner } from '@components/LoggedInHeader';
import SiteBannerHost from '@components/SiteBannerHost';
import PickListCompletionDialog from '@components/PickListCompletionDialog';
import { Outlet } from 'react-router-dom';
import { components } from '@theme/classNames';
import { useAppState } from '@state/AppStateProvider';

const MainLayout = ({ onLogout }) => {
  const { getState } = useAppState();
  const appState = getState({ context: 'app' });
  const hasEnvironmentBanner = hasLoggedInHeaderEnvironmentBanner(process.env.REACT_APP_BB_ENV);
  const mainOffsetClassName = hasEnvironmentBanner ? 'mt-[calc(var(--header-height)+2.5rem)]' : 'mt-[var(--header-height)]';
  const mainHeight = `calc(100vh - var(--header-height)${hasEnvironmentBanner ? ' - 2.5rem' : ''})`;

  return (
    <div className={`fixed inset-0 flex flex-col h-screen ${components.card.base}`}>
      <SiteBannerHost />
      <PickListCompletionDialog isOpen={appState?.pickListCompletionDialog?.isOpen ?? false} />
      <header className="fixed top-0 left-0 right-0 z-50">
        <LoggedInHeader onLogout={onLogout} />
      </header>
      <main
        className={`fixed top-0 left-0 right-0 bottom-0 ${mainOffsetClassName} ${components.card.content}`}
        style={{
          height: mainHeight
        }}
      >
        <div className="h-full overflow-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default MainLayout;
